import React, {Component, Fragment} from 'react';
import {ModalLoader as Loader, Overlay, Wrapper} from './styles';
import Portal from "../portal/Portal";

class ModalLoader extends Component
{
  static pageYOffset = 0;

  constructor(props)
  {
    super(props);

    this.state = {
      show: props.show,
      fade: props.show
    }
  }


  render()
  {
    return <Fragment>
      <Portal id={'loader'}>
        <Overlay show={this.props.show}>
          <Wrapper>
            <Loader/>
          </Wrapper>
        </Overlay>
      </Portal>
    </Fragment>
  }
}

export default ModalLoader
